import React, { useEffect, useMemo } from "react";
import styled, { css } from "styled-components";
import { ProductCard } from "../../components/productCard";
import { useProduce, useProductTypes } from "../../hooks/useProducts";
import {
  FaCartPlus,
  FaLocationArrow,
  FaShoppingBasket,
  FaTrash,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Logo from "../../assets/logo/new_logo_colored2.png";
import { slide as Menu } from "react-burger-menu";
import { useState } from "react";
import { Button } from "../../components/button";
import { useCart } from "../../subjects/CartContext";
import { thousands_separators } from "../../utils/formatCurrency";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useForm } from "react-hook-form";
import { getCurrentWarehouse } from "../../utils/getCurrentWarehouse";
import {
  BranchSelectionModal,
  SELECTED_BRANCH_KEY,
} from "../../components/modal/branchModal";
import { EmptyStateComponent } from "../../components/modal/emptyState";
import {
  DiscountProductCard,
  RegularProductCard,
} from "../../components/productCard/cards";

const getProductImage = (name) => {
  let image;
  switch (true) {
    case name.toLowerCase().includes("tilapia"):
      image =
        "https://api.beta.markiti.laheri.co.ke/upload/2dda0c86-f866-11ed-aba4-b526e0ab41d1-Tilapia-001_copy.jpg";
      break;
    case name.toLowerCase().includes("nile"):
    case name.toLowerCase().includes("cat"):
      image = require("../../assets/pictures/NP-steak.jpeg");
      break;
    case name.toLowerCase().includes("fillet"):
      image = require("../../assets/pictures/Fillet.jpeg");
      break;
    case name.toLowerCase().includes("omena"):
      image = require("../../assets/pictures/omena.jpeg");
      break;
    case name.toLowerCase().includes("chicken"):
      image = require("../../assets/pictures/chicken.jpeg");
      break;
    default:
      image = require("../../assets/pictures/chicken.jpeg");
      break;
  }
  return image;
};
// FryOption replacement — drop into Products.js (or extract to its own file)

const DeepFrySelector = ({ totalQty, friedQty, deepFryCost, onChange }) => {
  const setFried = (next) => onChange(Math.max(0, Math.min(next, totalQty)));

  return (
    <FrySelectorWrap>
      <FryText>
        Deep fry <strong>{friedQty}</strong> of {totalQty}
        {deepFryCost > 0 && <FryCost> (+Ksh. {deepFryCost}/item)</FryCost>}
      </FryText>

      <FryStepper>
        <FryStepBtn
          type="button"
          disabled={friedQty <= 0}
          onClick={() => setFried(friedQty - 1)}
          aria-label="Fewer deep fried"
        >
          −
        </FryStepBtn>
        <FryStepValue>{friedQty}</FryStepValue>
        <FryStepBtn
          type="button"
          disabled={friedQty >= totalQty}
          onClick={() => setFried(friedQty + 1)}
          aria-label="More deep fried"
        >
          +
        </FryStepBtn>
      </FryStepper>
    </FrySelectorWrap>
  );
};

const isFryEligible = (name) => name?.toLowerCase().includes("tilapia");

var styles = {
  bmBurgerButton: {
    position: "fixed",
    width: "36px",
    height: "30px",
    right: "36px",
    top: "15px",
    zIndex: 1000,
  },
  bmBurgerBars: {
    background: "#fff",
  },
};

const Products = () => {
  const [selectedFilter, setSelectedFilter] = useState("");
  const { watch } = useForm();
  const [isOpen, setIsOpen] = useState(false);
  const { data: products } = useProduce(selectedFilter);
  const { data: product_types } = useProductTypes();
  const {
    items,
    getTotalPrice,
    removeItem,
    getItemsCount,
    setDeepFriedQuantity,
    deepFryCost,
    getDeepFryFee,
  } = useCart();

  const history = useHistory();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(() => {
    try {
      const savedBranch = localStorage.getItem(SELECTED_BRANCH_KEY);
      return savedBranch ? JSON.parse(savedBranch) : null;
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return null;
    }
  });
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  // Function to handle branch selection from the modal
  const handleSelectBranch = (branch) => {
    setSelectedBranch(branch);
  };
  const handleFilterChange = (id) => {
    const selectedType = product_types?.find((t) => t.id === id);
    const slug = selectedType
      ? selectedType.name.toLowerCase().replace(/\s+/g, "-")
      : "";

    setSelectedFilter(id);

    // FIX: Using history.location.pathname ensures clean URL synchronization
    history.push({
      pathname: history.location.pathname,
      search: slug ? `?product_type=${slug}` : "",
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    const categorySlug = params.get("product_type");

    if (categorySlug && product_types?.length > 0) {
      const matchedType = product_types.find(
        (t) => t.name.toLowerCase().replace(/\s+/g, "-") === categorySlug,
      );
      if (matchedType) {
        setSelectedFilter(matchedType.id);
      }
    } else if (!categorySlug) {
      setSelectedFilter(""); // Reverts safely to "All" if url param is cleared
    }
  }, [product_types, history.location.search]);
  const groupedCartItems = useMemo(() => {
    const map = new Map();
    items.forEach((item) => {
      const key = item.product.id;
      if (!map.has(key)) {
        map.set(key, {
          product: item.product,
          totalQty: 0,
          friedQty: 0,
          totalPrice: 0,
        });
      }
      const group = map.get(key);
      group.totalQty += item.qty;
      if (item.deep_fried) group.friedQty += item.qty;
      group.totalPrice += item.discountedTotal || item.totalPrice;
    });
    return Array.from(map.values());
  }, [items]);

  return (
    <>
      <Container>
        <NavbarContainer>
          <LogoContainer onClick={() => window.location.replace("/")}>
            <LogoImg src={Logo} />
          </LogoContainer>
          <LocationContainer>
            <BranchContainer onClick={openModal}>
              <FaMapMarkerAlt size={24} color="#494395" />
              <div>
                <p>{selectedBranch?.name}</p>
                <strong>{selectedBranch?.code}</strong>
              </div>
            </BranchContainer>
            <BrandContainer onClick={() => setIsOpen(true)}>
              <FaCartPlus size={24} color="#494395" />
              <span>{getItemsCount()}</span>
            </BrandContainer>
          </LocationContainer>
        </NavbarContainer>
        <Header>
          <Title>{/* Our <span>Products</span> */}</Title>
        </Header>

        <ProductsContainer>
          <div>
            <strong>Filters</strong>
            <FiltersContainers>
              <Filter
                active={selectedFilter === ""}
                onClick={() => handleFilterChange("")}
              >
                All
              </Filter>
              {product_types
                ?.filter((type) => type.id !== 4)
                ?.sort((a, b) => {
                  const priorityIds = [1, 2, 5, 9, 8, 7, 3];

                  const indexA = priorityIds.indexOf(a.id);
                  const indexB = priorityIds.indexOf(b.id);

                  const posA = indexA === -1 ? 99 : indexA;
                  const posB = indexB === -1 ? 99 : indexB;

                  return posA - posB;
                })
                ?.map((type) => (
                  <Tippy content={type?.description} key={type.id}>
                    <Filter
                      active={selectedFilter === type.id} // Use handleFilterChange here
                      onClick={() => handleFilterChange(type.id)}
                    >
                      {type.name}
                    </Filter>
                  </Tippy>
                ))}
            </FiltersContainers>
          </div>

          {products?.length > 0 ? (
            <ProductList>
              {products
                ?.filter(
                  (prod) =>
                    prod.id !== "66d580f5-6b81-49a3-bde0-7305c7c407fe" &&
                    prod.id !== "2d1c4fe1-4be1-4f36-bfb5-159a42deb61e" &&
                    !prod?.name.includes("Byproducts"),
                )
                ?.map((item) => {
                  return item?.discount_amount ? (
                    <DiscountProductCard
                      product={item}
                      key={item.id}
                      description={item?.description}
                      title={item.name}
                      price={item.unit_value}
                      backgroundColor="white"
                      qty_available={item?.quantity_available_for_sale}
                      itemInCart={items?.find(
                        (prod) => prod?.product.id === item.id,
                      )}
                      discounted_price={item?.discounted_price}
                      discount_amount={item?.discount_amount}
                      // imgUrl={getProductImage(item.display_name)}
                      imgUrl={
                        item?.product_images?.length
                          ? item?.product_images[0]?.url
                          : getProductImage(item.display_name)
                      }
                    />
                  ) : (
                    <RegularProductCard
                      product={item}
                      key={item.id}
                      description={item?.description}
                      title={item.name}
                      price={item.unit_value}
                      backgroundColor="white"
                      qty_available={item?.quantity_available_for_sale}
                      itemInCart={items?.find(
                        (prod) => prod?.product.id === item.id,
                      )}
                      discounted_price={item?.discounted_price}
                      discount_amount={item?.discount_amount}
                      // imgUrl={getProductImage(item.display_name)}
                      imgUrl={
                        item?.product_images?.length
                          ? item?.product_images[0]?.url
                          : getProductImage(item.display_name)
                      }
                    />
                  );
                })}
            </ProductList>
          ) : (
            <EmptyStateComponent />
          )}
        </ProductsContainer>
      </Container>
      <BurgerMenu
        styles={styles}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        isOpen={isOpen}
        outerContainerId={"outer-container"}
        customBurgerIcon={false}
        right
      >
        <CartDrawerWrapper>
          {/* Header */}
          <MenuHeader>
            <FaShoppingBasket size={24} color="#747577" />
            <HeaderTitle>{getItemsCount()} items</HeaderTitle>
          </MenuHeader>

          {/* Scrollable Item Container */}
          <CartItemsScrollArea>
            {groupedCartItems?.map((group) => {
              const fryEligible = isFryEligible(group.product?.display_name);
              const lineTotal = group.product?.discounted_price
                ? group.totalQty * group.product.discounted_price
                : group.totalPrice;

              return (
                <CartItem key={group.product?.id}>
                  <CartItemTop>
                    <CartItemName>{group.product?.display_name}</CartItemName>
                    <DeleteButton
                      onClick={() => removeItem(group.product?.id)}
                      aria-label="Remove product"
                    >
                      <FaTrash size={14} />
                    </DeleteButton>
                  </CartItemTop>

                  <CartItemMeta>
                    <MetaText>
                      {group.totalQty} × Ksh.{" "}
                      {thousands_separators(group.product?.unit_value)}
                    </MetaText>
                    <CartItemPrice>
                      Ksh. {thousands_separators(lineTotal?.toFixed(0))}
                    </CartItemPrice>
                  </CartItemMeta>

                  {fryEligible && (
                    <DeepFrySelector
                      totalQty={group.totalQty}
                      friedQty={group.friedQty}
                      deepFryCost={deepFryCost}
                      onChange={(val) =>
                        setDeepFriedQuantity(group.product.id, val)
                      }
                    />
                  )}
                </CartItem>
              );
            })}
          </CartItemsScrollArea>

          {/* Summary & Checkout Stick to Bottom */}
          <CartBottomStickySection>
            {(getDeepFryFee() > 0 ||
              (items?.length && getTotalPrice() < 4000)) && (
              <SummarySectionCard>
                {getDeepFryFee() > 0 && (
                  <FeeRow>
                    <FeeLabel>Deep Fry Fee</FeeLabel>
                    <FeeValue>
                      Ksh. {thousands_separators(getDeepFryFee())}
                    </FeeValue>
                  </FeeRow>
                )}
                {items?.length && getTotalPrice() < 4000 && (
                  <FeeRow>
                    <FeeLabel>Delivery Fee</FeeLabel>
                    <FeeValue>Ksh. 400</FeeValue>
                  </FeeRow>
                )}
              </SummarySectionCard>
            )}

            <CheckOutActions>
              <CheckoutButton onClick={() => history.push("/checkout")}>
                <CheckoutText>Checkout Now</CheckoutText>
                <CheckoutTotalPrice>
                  Ksh. {thousands_separators(getTotalPrice())}
                </CheckoutTotalPrice>
              </CheckoutButton>
            </CheckOutActions>
          </CartBottomStickySection>
        </CartDrawerWrapper>
      </BurgerMenu>

      <BranchSelectionModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        onSelectBranch={handleSelectBranch}
      />
    </>
  );
};

const Container = styled.div`
  display: grid;
  background-color: #f6f9fc;
  padding-bottom: 1rem;
`;

const BranchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0rem 1rem;
  cursor: pointer;
  div {
    p {
      font-weight: bold;
      color: #494395;
      padding: 0rem;
      margin: 0rem;
    }
    strong {
      font-weight: bold;
      padding: 0rem;
      margin: 0rem;
    }
  }
  @media (max-width: 600px) {
    display: none;
  }
`;

const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0rem 1rem;
  cursor: pointer;
`;
const FiltersContainers = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-evenly;
  align-items: center;
  margin: 1rem 0rem;
  column-gap: 1rem;
  row-gap: 1rem;
  @media (min-width: 600px) {
    grid-template-columns: repeat(3, 11.5rem);
    column-gap: 1rem;
  }
  @media (min-width: 900px) {
    grid-template-columns: repeat(9, 8.5rem);
    column-gap: 1rem;
  }
`;

const Filter = styled.div`
  padding: 0.5rem;
  background-color: ${(props) => (props?.active ? "#494395" : "white")};
  color: ${(props) => (props?.active ? "white" : "#494395")};
  border-radius: 0.5rem;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5rem;
`;

const Title = styled.h3`
  font-size: 3.5rem;

  span {
    color: #494395;
  }
  @media screen and (max-width: 670px) {
    font-size: 1.5rem;
  }
`;

const ProductsContainer = styled.div`
  margin: 0 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const ProductList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  row-gap: 1rem;

  @media (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 1rem;
  }
  @media (min-width: 900px) {
    grid-template-columns: repeat(4, 1fr);
    column-gap: 1rem;
  }
`;
const NavbarContainer = styled.div`
  width: 100%;
  padding: 0.5rem 2em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  position: fixed;
  z-index: 10;
  color: black;
`;

const BrandContainer = styled.div`
  cursor: pointer;
  position: relative;
  border-radius: 5px;
  border: 1px solid #494395;
  background-color: rgba(73, 67, 149, 0.1);
  padding: 0.5rem;
  span {
    background-color: red;
    color: white;
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -10px;
    right: -5px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: ${({ inline }) => (inline ? "row" : "column")};
  align-items: center;
  @media screen and (max-width: 670px) {
    margin-top: 0.5rem;
  }
`;

const LogoImg = styled.img`
  width: 200px;
  height: 70px;

  @media screen and (max-width: 670px) {
    width: 100px;
    height: 40px;
  }

  ${({ inline }) =>
    inline &&
    css`
      width: 24px;
      height: 24px;
      margin-right: 6px;
    `};

  ${({ small }) =>
    small &&
    css`
      width: 8em;
      height: 8em;
    `};
`;

// Unified flex grid block ensuring absolute layout containment inside the drawer
const CartDrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff; /* Clean white background */
  box-sizing: border-box;
`;

const MenuHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 1.5rem 1.25rem; /* Increased padding to expand header zone */
  border-bottom: 2px solid #f1f5f9; /* Defined clean border separation */
`;

const HeaderTitle = styled.p`
  margin: 0 0 0 1rem;
  font-size: 1.4rem; /* Scaled up from 1.15rem */
  font-weight: bold;
  color: #4a5568 !important; /* Richer shade for prominent header text */
`;

const CartItemsScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.25rem 0; /* Extra top/bottom spacing for items */

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
`;

const CartItem = styled.div`
  background: #f8fafc; /* Light structural card surface */
  border: 1px solid #e2e8f0;
  border-radius: 0.85rem;
  padding: 1.25rem; /* Expanded padding inside each product row */
  margin: 0 1.25rem 1rem; /* Scaled horizontal and vertical tracking margins */
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`;

const CartItemTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
`;

const CartItemName = styled.p`
  font-size: 1.1rem; /* Scaled up from 0.9rem to beautifully fill layout space */
  font-weight: bold;
  color: #1a202c;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #a0aec0;
  cursor: pointer;
  padding: 0.35rem; /* Larger tap target */
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    color 0.15s ease,
    transform 0.15s ease;

  &:hover {
    color: #ef4444;
    transform: scale(1.1);
  }

  svg {
    width: 16px; /* Scaled up delete icon frame */
    height: 16px;
  }
`;

const CartItemMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.85rem; /* Generous separation below the title */
`;

const MetaText = styled.span`
  font-size: 0.95rem; /* Scaled up from 0.8rem */
  color: #64748b;
  font-weight: 500;
`;

const CartItemPrice = styled.span`
  font-size: 1.1rem; /* Scaled up from 0.9rem */
  font-weight: 800; /* Extra bold highlight for item total pricing */
  color: #1a202c;
`;

/* Light Theme Fry Selector Stepper Block */
const FrySelectorWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1.1rem;
  padding-top: 1.1rem;
  border-top: 1px dashed #cbd5e1;
`;

const FryText = styled.span`
  font-size: 0.9rem; /* Scaled up from 0.75rem */
  color: #475569;
  line-height: 1.3;
  strong {
    color: #0f172a;
    font-weight: bold;
  }
`;

const FryCost = styled.span`
  display: block;
  font-size: 0.8rem; /* Scaled up from 0.7rem */
  color: #64748b;
  margin-top: 0.15rem;
`;

const FryStepper = styled.div`
  display: flex;
  align-items: center;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 2rem;
  padding: 3px; /* Slightly chunkier pill casing wrapper */
`;

const FryStepBtn = styled.button`
  width: 1.85rem; /* Scaled step buttons from 1.65rem */
  height: 1.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  background: ${({ disabled }) => (disabled ? "transparent" : "#ffffff")};
  color: ${({ disabled }) => (disabled ? "#94a3b8" : "#494395")};
  box-shadow: ${({ disabled }) =>
    disabled ? "none" : "0 1px 4px rgba(0,0,0,0.08)"};
  font-size: 1.1rem;
  font-weight: bold;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: #494395;
    color: #ffffff;
  }
`;

const FryStepValue = styled.span`
  min-width: 1.6rem; /* Clean alignment for counters */
  text-align: center;
  font-weight: bold;
  font-size: 0.95rem; /* Scaled up from 0.8rem */
  color: #1e293b;
`;

/* Sticky Bottom Drawer Configurations */
const CartBottomStickySection = styled.div`
  background: #ffffff;
  border-top: 2px solid #f1f5f9;
  padding: 1.5rem 1.25rem; /* Roomier spacing dock */
  margin-top: auto;
  box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.03);
`;

const SummarySectionCard = styled.div`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.85rem;
  padding: 1.1rem;
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* Extra separation for subtotal rows */
`;

const FeeRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem; /* Scaled up from 0.8rem */
`;

const FeeLabel = styled.span`
  color: #64748b;
  font-weight: 500;
`;

const FeeValue = styled.span`
  font-weight: bold;
  color: #0f172a;
`;

const CheckOutActions = styled.div`
  width: 100%;
`;

const CheckoutButton = styled.button`
  width: 100%;
  background: #494395;
  border: none;
  border-radius: 0.65rem;
  padding: 1.15rem 1.5rem; /* Chunkier padding targets */
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.1s ease;

  &:hover {
    background: #3b357a;
  }
  &:active {
    transform: scale(0.99);
  }
`;

const CheckoutText = styled.span`
  font-size: 1.15rem; /* Scaled up from 1rem */
  font-weight: bold;
  color: #ffffff;
`;

const CheckoutTotalPrice = styled.span`
  font-size: 1.1rem; /* Scaled up from 0.95rem */
  font-weight: bold;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.18);
  padding: 0.4rem 1rem; /* Generous tags */
  border-radius: 0.5rem;
`;

/* Reverted Burger Menu Width Styles to Original Parameters */
const BurgerMenu = styled(Menu)`
  width: 25% !important; /* Restored original 25% configuration */
  height: 100%;
  position: absolute;
  top: 0;

  .bm-menu {
    z-index: 10;
    background: #ffffff; /* Clean white sidebar canvas */
    box-shadow: -1px 0px 5px 1px #aaaaaa;
    height: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .bm-cross {
    background: #747577;
  }
  .bm-overlay {
    background: rgba(0, 0, 0, 0.3) !important;
    top: 0;
    left: 0;
  }
  .bm-item-list {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-top: 0;
  }

  @media screen and (max-width: 670px) {
    width: 100% !important; /* Desktop-to-mobile width override constraint protection */
    height: 100% !important;
  }
`;

export default Products;
